import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { ISelectedStudent } from '../Models/ISelectedStudent';
import { IStudentEnrollment } from '../Models/IStudentEnrollment';

@Injectable()
export class StudentService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  get(url: string): Observable<ISelectedStudent> {
    return this._http.get<ISelectedStudent>(url).map((response: ISelectedStudent) => response as ISelectedStudent)
      .catch(this.handleError);
  }

  getStudentEnrollments(localStudentId: string): Observable<IStudentEnrollment[]> {
    return this._http.get<IStudentEnrollment[]>(this._baseUrl + "api/Student/GetStudentEnrollments/" + localStudentId)
      .map((response: IStudentEnrollment[]) => response as IStudentEnrollment[])
      .catch(this.handleError);
  }

  getContiguousStudentEnrollments(localStudentId: string): Observable<IStudentEnrollment[]> {
    return this._http.get<IStudentEnrollment[]>(this._baseUrl + "api/Student/GetContiguousStudentEnrollments/" + localStudentId)
      .map((response: IStudentEnrollment[]) => response as IStudentEnrollment[])
      .catch(this.handleError);
  }

}
